<div [class.loading-shimmer]="showLoading()" [style.width]="showLoading() ? width() : 'auto'">
  <span #contentWrapper [class.opacity-0]="showLoading()">
    <ng-content></ng-content>
  </span>
  @if (!contentWrapper.children.length) {
    &nbsp;
  }
</div>
